import {
  i
} from "./chunk.775UL347.js";

// src/components/jb-news-overlay/jb-news-overlay.css.ts
var jb_news_overlay_css_default = i`.sr-only{block-size:1px;border:0;clip:rect(0, 0, 0, 0);inline-size:1px;margin:-1px;overflow:hidden;padding:0;position:absolute}:host{display:block;min-height:100vh}.news-overlay{display:flex;flex-direction:column;gap:var(--theme-spacing-between-components-small);opacity:0}@media(min-width: 1281px){.news-overlay{gap:var(--theme-spacing-between-components-medium)}}`;

export {
  jb_news_overlay_css_default
};
